"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandContainer = exports.MagnifyGlass = exports.SlideIndicators = exports.Indicator = exports.IndicatorsContainer = exports.Slide = exports.Slides = exports.RightArrow = exports.LeftArrow = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Container = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  position: relative;
  background-color: ${colors_1.LIGHT_GREY};
  overflow: hidden;
`;
const CommonArrow = styled_components_1.default.div `
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 30px;
  display: flex;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
  color: ${({ $isDark }) => ($isDark ? colors_1.GREY3 : colors_1.LIGHT_GREY)};
  opacity: 80%;

  &:hover {
    color: ${colors_1.GREY2};
  }
`;
exports.LeftArrow = (0, styled_components_1.default)(CommonArrow) `
  left: 16px;
`;
exports.RightArrow = (0, styled_components_1.default)(CommonArrow) `
  right: 16px;
`;
exports.Slides = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  margin: auto;
  display: -webkit-box;
  transition: transform 0.4s ease-in-out;
  cursor: ${({ $magnifyActive }) => ($magnifyActive ? "none" : "default")};
`;
exports.Slide = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background: ${({ $image }) => $image};
`;
exports.IndicatorsContainer = styled_components_1.default.div `
  display: flex;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0);
  gap: 10px;
`;
exports.Indicator = styled_components_1.default.div `
  width: 50px;
  height: 3px;
  opacity: 80%;
  background-color: ${({ $isDark, $isSelected }) => $isDark ? ($isSelected ? colors_1.DARK_GREEN : colors_1.GREY3) : $isSelected ? colors_1.DARK_GREEN : colors_1.LIGHT_GREY};
`;
exports.SlideIndicators = styled_components_1.default.div `
  display: flex;
  align-items: center;
  height: 20px;
  cursor: ${({ $isSelected }) => ($isSelected ? "default" : "pointer")};

  &:hover ${exports.Indicator} {
    background-color: ${({ $isSelected }) => ($isSelected ? "" : colors_1.GREY2)};
  }
`;
exports.MagnifyGlass = styled_components_1.default.div `
  position: absolute;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  pointer-events: none;
  width: 100px;
  height: 100px;
  background: ${({ $image }) => $image};
  background-color: ${colors_1.WHITE};
  background-repeat: no-repeat;
  background-size: auto;
  box-shadow: 6px 6px 20px rgba(0, 0, 0, 0.1), -6px -6px 20px rgba(0, 0, 0, 0.1);
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  scale: ${({ $isActive }) => ($isActive ? 1 : 0)};
  transition: opacity ease-in 0.3s, scale ease-in 0.3s;
`;
exports.ExpandContainer = styled_components_1.default.div `
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  color: ${({ $isDark }) => ($isDark ? colors_1.GREY3 : colors_1.LIGHT_GREY)};
  padding: 8px;
  opacity: 80%;

  &:hover {
    color: ${colors_1.GREY2};
  }
`;
//# sourceMappingURL=ImageCarousel.styles.js.map